import { getParts } from './utils/getParts';

const decoder = new TextDecoder('iso8859-1');

export function hgParseThermoFinnigan(blob) {
  let text = decoder.decode(blob);

  let lines = text.split(/\r?\n/);
  let parts = getParts(lines);
  let meta = {
    solidReporting: parseMeta(parts, 'SOLID REPORTING'),
    testInformation: parseMeta(parts, 'TEST INFORMATION'),
    analyticalConditions: parseMeta(parts, 'ANALYTICAL CONDITIONS'),
    preparation: parseMeta(parts, 'PREPARATION'),
    totalPoreSize: parseMeta(parts, 'TOTAL PORE SIZE'),
    tableTotalPoreSize: parseTable(parts, 'TABLE TOTAL PORE SIZE'),
    tableTotalSurfaceArea: parseTable(parts, 'TABLE TOTAL SURFACE AREA'),
  };

  let variables = parseExperimentalData(parts['EXPERIMENTAL DATA']);

  return { meta, variables };
}

function parseTable(parts, label) {
  let lines = parts[label].map((line) =>
    line
      .replace(/,+$/, '')
      .split(/; * /)
      .map((field) => field.trim()),
  );

  let headers = lines[0]
    .filter((field) => field)
    .map((field, index) => `${field}[${lines[1][index].replace(/[()]/g, '')}]`);

  let result = [];
  for (let i = 2; i < lines.length; i++) {
    const line = lines[i];
    const currentLine = {};
    headers.forEach((header, index) => (currentLine[header] = line[index]));
    result.push(currentLine);
  }
  return result;
}

function parseMeta(parts, label) {
  let parsed = {};
  for (let line of parts[label]) {
    let label = line.replace(/^(.*?); *(.*)$/, '$1').replace(/:? *$/, '');
    let value = line
      .replace(/^(.*?); *(.*)$/, '$2')
      .replace(/,+$/, '')
      .replace(' : ; ', ' : ');
    if (!isNaN(value)) {
      value = Number(value);
    }
    parsed[label] = value;
  }
  return parsed;
}

function parseExperimentalData(lines) {
  let variables = lines[0]
    .replace(/,+$/, '')
    .split(/; * /)
    .map((header) => header.trim())
    .map((line, index) => {
      return {
        symbol: String.fromCharCode(index + 65),
        data: [],
        label: line.replace(/ ?\(.*/, ''),
        units: line.replace(/.*\((.*)\).*/, '$1'),
      };
    });

  for (let i = 1; i < lines.length; i++) {
    let fields = lines[i].replace(/,*$/, '').split(/ *; */);
    for (let j = 0; j < variables.length; j++) {
      variables[j].data.push(Number(fields[j]));
    }
  }

  const variablesObject = {};
  variables.forEach((variable) => {
    variablesObject[variable.symbol] = {
      data: variable.data,
      units: variable.units,
      label: variable.label,
    };
  });

  return variablesObject;
}
